import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';
import { getErrorMessage, markFormGroupTouched } from '@utils';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { ClientesService } from '../../../services/clientes.service';
import { CidadesService } from '../../../services/cidades.service';
import { EstadosService } from '../../../services/estados.service';
import { lastValueFrom } from 'rxjs';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2';
import { NotasFiscaisService } from '../../../services/notas-fiscais.service';

@Component({
  selector: 'app-vendas-por-cliente-cidade',
  templateUrl: './vendas-por-cliente-cidade.component.html',
  styleUrls: ['./vendas-por-cliente-cidade.component.css']
})
export class VendasPorClienteCidadeComponent extends ModalCadastroComponent implements OnInit {

  constructor(
    private estadoService: EstadosService,
    private cidadeService: CidadesService,
    private clientesService: ClientesService,
    private notasFiscaisService: NotasFiscaisService,
  ) { super() }

  @ViewChild('modalRelatorio', { static: true }) modalRelatorio;
  impressaoForm: FormGroup;
  cidadesMap = [];
  estadosMap = [];

  statusOptions = [
    { label: 'Todos', value: 'T' },
    { label: 'Ativos', value: 'A' },
    { label: 'Inativos', value: 'I' }
  ];

  ngOnInit(): void {
    this.impressaoForm = new FormGroup({
      dataInicial: new FormControl(moment().startOf('month').toDate(), [Validators.required]),
      dataFinal: new FormControl(null),
      estadoId: new FormControl(null),
      cidadeId: new FormControl(null),
      clientes: new FormControl("T"),
      tipo: new FormControl("C")
    });

    this.estadoService.get()
      .subscribe(res => {
        this.estadosMap = res;
      });

    this.getUltimaCompra();
    this.getCidade(null);
  }

  destroyComponent() {
    this.closed.emit();
  }

  show(): void {
    this.modalRelatorio.show();
  }

  onChangeEstado(estadoId: any) {
    this.getCidade(estadoId);
    this.impressaoForm.controls['cidadeId'].setValue(null);
  }

  getCidade(estadoId) {
    if (estadoId != null) {
      this.cidadeService.getByEstado(estadoId)
        .subscribe(res => {
          this.cidadesMap = res;
        });
    } else {
      this.cidadeService.get()
        .subscribe(res => {
          this.cidadesMap = res;
        });
    }
  }

  validaForm() {
    markFormGroupTouched(this.impressaoForm);
  }

  async getUltimaCompra() {
    try {
      this.loading['buscandoData'] = true;
      const res = await lastValueFrom(this.notasFiscaisService.ObterUltimaCompra());
      this.impressaoForm.get('dataFinal').setValue(res);
    } catch (error) {
      console.error(error);
    } finally {
      this.loading['buscandoData'] = false;
    }
  }

  async submitForm() {
    if (this.impressaoForm.invalid) {
      return;
    }

    try {
      this.loading['imprimindo'] = true;
      const res = await lastValueFrom(this.clientesService.imprimirRelatorioVendasPorClienteCidade(this.impressaoForm.value));
      saveAs(res, 'venda_por_cliente_cidade.pdf');
      this.modalRelatorio.hide();
      this.closed.emit();
    } catch (error) {
      Swal("Erro ao emitir o relatório: Vendas por Cliente/Cidade", getErrorMessage(error), "error");
      console.error(error);
    } finally {
      this.loading['imprimindo'] = false;
    }
  }
}
